import { useMutation, useQueryClient } from '@tanstack/react-query';
import { userCardAPI } from '../api/userCardAPI';

export const useDeleteCard = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (id: number) => await userCardAPI.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['card-list'] });
    },
  });

  return {
    deleteCard: mutateAsync,
    isPending,
  };
};
